import parsePhoneNumberFromString, { AsYouType } from "libphonenumber-js";

export const phoneIsValid = (phoneNumber: string, country: any, t: any) => {
  if (country === "CH" && phoneNumber.startsWith("0")) {
    return t`errors.input.leadingZeroNotAllowed`;
  }

  const phone = parsePhoneNumberFromString(phoneNumber, country);
  const isValid = phone ? phone.isValid() : false;
  return isValid || t`errors.input.invalidPattern`;
};

export const parsePhoneNumber = (prefix: string, phoneNumber: string) => {
  return new AsYouType()
    .input(`${prefix}${phoneNumber}`)
    .replace(" ", "")
    .replace(new RegExp(`^\\${prefix}\\s?`), "");
};
